import * as React from "react";
import { Box } from "@mui/material";
import logoWhite from "./tickit-white-transparent.png";
import logoPurple from "./tickit-purple-transparent.png";
import { useThemeMode } from "./theme/ThemeModeProvider";
import { usesPlatformChrome } from "./platform/pageChrome";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";

function TickitLogoInner({ variant = "auto", height = 40, onClick, role, sx = {} }) {
  const { mode } = useThemeMode();
  const { pathname } = useLocation();
  const platformMode = usesPlatformChrome(pathname, role);

  let src = logoPurple;
  if (variant === "onDark") src = logoWhite;
  else if (variant === "onLight") src = logoPurple;
  else if (platformMode || mode === "dark" || role === "Usher") src = logoWhite;

  return (
    <Box
      onClick={onClick}
      sx={{
        display: "inline-flex",
        alignItems: "center",
        cursor: onClick ? "pointer" : "default",
        ...sx,
      }}
    >
      <Box
        component="img"
        src={src}
        alt="Tickit"
        sx={{ height, width: "auto", display: "block" }}
      />
    </Box>
  );
}

const mapStateToProps = (state) => ({
  role: state?.auth?.token?.split(" ")[0],
});

export default connect(mapStateToProps)(TickitLogoInner);
